import React, { useId } from 'react'

export const VerifiedPageCard: React.FC = () => {
  const clipPathId = useId()

  return (
    <span className="group/icon relative inline-flex shrink-0 align-middle">
      <span aria-label="Verified" title="Verified">
        <svg className="h-5 w-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <g clipPath={`url(#${clipPathId})`}>
            <path
              fill="#4dc4ff"
              d="M13.355 1.47a1.75 1.75 0 0 0-2.709 0l-.991 1.211a.25.25 0 0 1-.282.076l-1.465-.553a1.75 1.75 0 0 0-2.345 1.354L5.31 5.103a.25.25 0 0 1-.207.206l-1.545.253a1.75 1.75 0 0 0-1.354 2.346l.553 1.464a.25.25 0 0 1-.075.282l-1.211.992a1.75 1.75 0 0 0 0 2.708l1.211.992a.25.25 0 0 1 .075.282l-.553 1.464a1.75 1.75 0 0 0 1.354 2.346l1.545.253a.25.25 0 0 1 .207.206l.253 1.545a1.75 1.75 0 0 0 2.345 1.354l1.465-.553a.25.25 0 0 1 .282.076l.992 1.211a1.75 1.75 0 0 0 2.708 0l.991-1.211a.25.25 0 0 1 .282-.076l1.465.553a1.75 1.75 0 0 0 2.345-1.354l.254-1.545a.25.25 0 0 1 .206-.206l1.545-.253a1.75 1.75 0 0 0 1.354-2.346l-.553-1.464a.25.25 0 0 1 .075-.282l1.212-.992a1.75 1.75 0 0 0 0-2.708l-1.212-.992a.25.25 0 0 1-.075-.282l.553-1.464a1.75 1.75 0 0 0-1.354-2.346l-1.545-.253a.25.25 0 0 1-.206-.206l-.254-1.545a1.75 1.75 0 0 0-2.345-1.354l-1.465.553a.25.25 0 0 1-.282-.076z"
            />
            <path
              fill="#eceff1"
              fillRule="evenodd"
              d="M18.03 7.97a.75.75 0 0 1 0 1.06l-7 7a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06l3.47 3.47 6.47-6.47a.75.75 0 0 1 1.06 0"
              clipRule="evenodd"
            />
          </g>
          <defs>
            <clipPath id={clipPathId}>
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </svg>
      </span>
      <span
        role="tooltip"
        className="pointer-events-none absolute left-1/2 top-full z-10 mt-1 -translate-x-1/2 whitespace-nowrap rounded-full bg-green-50 px-1.5 py-0.5 text-[10px] font-medium leading-none text-green-800 opacity-0 ring-1 ring-green-200/80 transition-opacity duration-150 group-hover/icon:opacity-100"
      >
        Verified
      </span>
    </span>
  )
}
